import type { LocaleIso } from 'utils';
import { LOCALES_REQUIRING_PHONE_NUMBER } from '../constants';

export function isPhoneRequired(locale: LocaleIso): boolean {
  return LOCALES_REQUIRING_PHONE_NUMBER.includes(locale);
}
